// Contenuti delle pagine legali — versione definitiva (25 settembre 2026).

export const LEGAL_PAGES = {
  privacy: {
    path: "/privacy-policy",
    title: "Privacy Policy",
    metaTitle: "Privacy Policy | DS LAB STUDIO",
    intro:
      "Informativa sul trattamento dei dati personali ai sensi del Regolamento (UE) 2016/679 (GDPR). Ultimo aggiornamento: 25 settembre 2026.",
    sections: [
      {
        heading: "1. Titolare del trattamento",
        body: [
          "Il titolare del trattamento dei dati personali è Donato Spina, titolare del progetto DS LAB STUDIO.",
          "Per qualsiasi questione relativa alla privacy è possibile scrivere a: dslabstudio@libero.it.",
        ],
      },
      {
        heading: "2. Dati personali raccolti",
        body: [
          "Questo sito raccoglie esclusivamente i dati che l'utente fornisce volontariamente tramite il modulo di contatto: nome e cognome, nome dell'attività, settore e ruolo, indirizzo email, numero di telefono, preferenza di ricontatto e contenuto del messaggio.",
          "Non vengono raccolti dati di navigazione a fini di analisi o profilazione e non sono installati strumenti di tracciamento di terze parti.",
        ],
      },
      {
        heading: "3. Finalità e base giuridica",
        body: [
          "I dati forniti vengono utilizzati esclusivamente per esaminare la richiesta dell'utente e ricontattarlo utilizzando i recapiti indicati.",
          "Non vengono svolte attività di marketing, newsletter o profilazione.",
          "La base giuridica del trattamento è l'esecuzione di misure precontrattuali adottate su richiesta dell'interessato (art. 6, par. 1, lett. b, GDPR).",
        ],
      },
      {
        heading: "4. Modalità del trattamento e conservazione",
        body: [
          "Le richieste inviate tramite il modulo vengono trasmesse via email al titolare. Il sito non utilizza database per conservare le richieste: i dati non vengono salvati su sistemi del sito né conservati oltre il tempo necessario a gestire la richiesta e l'eventuale rapporto che ne deriva.",
        ],
      },
      {
        heading: "5. Fornitori tecnici",
        body: [
          "Per il funzionamento tecnico del sito sono coinvolti i seguenti fornitori, che possono trattare i dati secondo le rispettive informative privacy:",
          "Cloudflare, Inc. — hosting, distribuzione dei contenuti ed esecuzione delle funzioni serverless che gestiscono il modulo di contatto;",
          "Resend — invio tecnico delle email generate dal modulo di contatto.",
          "I dati non vengono ceduti o comunicati ad altri soggetti per finalità di marketing.",
        ],
      },
      {
        heading: "6. Diritti dell'interessato",
        body: [
          "L'utente può richiedere in qualsiasi momento l'accesso, la rettifica, la cancellazione o la limitazione del trattamento dei propri dati scrivendo a: dslabstudio@libero.it.",
          "È inoltre possibile proporre reclamo al Garante per la protezione dei dati personali.",
        ],
      },
      {
        heading: "7. Modifiche a questa informativa",
        body: [
          "Questa informativa può essere aggiornata nel tempo. La versione pubblicata su questa pagina è quella attualmente in vigore.",
        ],
      },
    ],
  },
  cookie: {
    path: "/cookie-policy",
    title: "Cookie Policy",
    metaTitle: "Cookie Policy | DS LAB STUDIO",
    intro:
      "Informazioni sull'utilizzo dei cookie e delle tecnologie analoghe su questo sito. Ultimo aggiornamento: 25 settembre 2026.",
    sections: [
      {
        heading: "1. Cosa sono i cookie",
        body: [
          "I cookie sono piccoli file di testo che i siti web possono salvare sul dispositivo dell'utente durante la navigazione, per garantire funzionalità tecniche o raccogliere informazioni.",
        ],
      },
      {
        heading: "2. Cookie e tecnologie utilizzate da questo sito",
        body: [
          "Questo sito non utilizza Google Analytics, Meta Pixel, cookie di profilazione, advertising tracker, strumenti di marketing né sistemi di analisi comportamentale.",
          "Il sito non installa cookie propri a fini di tracciamento. Possono essere presenti esclusivamente cookie o tecnologie strettamente necessarie al funzionamento tecnico e alla sicurezza della navigazione, gestite dal fornitore di hosting (Cloudflare).",
          "Trattandosi di cookie o tecnologie strettamente necessarie, non viene richiesto il consenso preventivo dell'utente e non è presente un cookie banner.",
        ],
      },
      {
        heading: "3. Contenuti di terze parti",
        body: [
          "Il sito non integra contenuti di terze parti che installano cookie propri (come video incorporati, mappe o widget social). Se in futuro dovessero essere integrati, questa pagina verrà aggiornata e, ove richiesto dalla normativa, verrà acquisito il consenso preventivo.",
        ],
      },
      {
        heading: "4. Come gestire i cookie",
        body: [
          "L'utente può in qualsiasi momento gestire o eliminare i cookie tramite le impostazioni del proprio browser. La disattivazione dei cookie tecnici potrebbe compromettere il corretto funzionamento del sito.",
        ],
      },
    ],
  },
  termini: {
    path: "/termini-e-condizioni",
    title: "Termini e condizioni",
    metaTitle: "Termini e condizioni | DS LAB STUDIO",
    intro:
      "DS LAB STUDIO è un progetto dedicato alla presentazione di servizi di realizzazione siti web, gestito da Donato Spina. Il presente sito ha finalità esclusivamente informative e di contatto. Ultimo aggiornamento: 25 settembre 2026.",
    sections: [
      {
        heading: "1. Natura del sito",
        body: [
          "Questo sito è una vetrina informativa: non vende prodotti o servizi direttamente online e non gestisce checkout, ordini, pagamenti, fatturazione né la conclusione automatica di contratti.",
          "La navigazione del sito non comporta alcun acquisto né alcun obbligo per l'utente.",
        ],
      },
      {
        heading: "2. Modulo di contatto",
        body: [
          "L'invio del modulo di contatto costituisce esclusivamente una richiesta di informazioni: non costituisce contratto né impegno vincolante per nessuna delle parti.",
          "Nessun pagamento viene effettuato tramite il sito.",
        ],
      },
      {
        heading: "3. Rapporti professionali",
        body: [
          "Eventuali rapporti professionali vengono concordati separatamente tra le parti, al di fuori del sito.",
          "Eventuali condizioni economiche, preventivi e modalità operative vengono definiti esternamente al sito. In caso di incarico, il cliente riceve un preventivo personalizzato prima dell'inizio dei lavori.",
        ],
      },
      {
        heading: "4. Dominio, hosting e servizi esterni",
        body: [
          "Per i progetti realizzati, dominio, hosting ed eventuali servizi esterni necessari al funzionamento del sito del cliente possono essere intestati e sostenuti direttamente dal cliente stesso.",
        ],
      },
      {
        heading: "5. Gestione successiva",
        body: [
          "Eventuali servizi di gestione, aggiornamento o assistenza successivi alla consegna di un progetto sono facoltativi e costituiscono un accordo separato tra le parti.",
        ],
      },
      {
        heading: "6. Contenuti forniti dal cliente",
        body: [
          "Testi, immagini, marchi, loghi e materiali forniti dal cliente restano di proprietà del cliente o dei rispettivi titolari. Il cliente garantisce di avere il diritto di utilizzarli e si assume la responsabilità relativa a contenuti, immagini, marchi e materiali forniti.",
        ],
      },
      {
        heading: "7. Servizi di terze parti",
        body: [
          "Il funzionamento tecnico di questo sito si avvale di servizi di terze parti (in particolare Cloudflare per hosting e funzioni serverless e Resend per l'invio tecnico delle email), regolati dai rispettivi termini e condizioni. DS LAB STUDIO non è responsabile di eventuali interruzioni o modifiche di tali servizi.",
        ],
      },
      {
        heading: "8. Contenuti del sito",
        body: [
          "I contenuti del sito hanno finalità informative e possono essere aggiornati nel tempo. I concept mostrati nella sezione Progetti sono esempi dimostrativi e non si riferiscono a clienti reali.",
        ],
      },
    ],
  },
};
